import React, { useEffect, useRef } from "react";
import { PageLayout } from "@features/shared";
import { useSelector, useDispatch } from "react-redux";
import { initializeEventListeners } from "@components/Common/Function";
import CurrentDayTour from "./CurrentDayTour";

const CurrentDayTourPage = () => {
  const dispatch = useDispatch();
  const expiryTime = useSelector((state) => state?.tokens?.creationDate);
  const eventCountRef = useRef(0);
  const hasEventListeners = useRef(false);

  useEffect(() => {
    const cleanup = initializeEventListeners(expiryTime, dispatch, eventCountRef, hasEventListeners);
    return cleanup;
  }, [expiryTime, dispatch]);

  return (
    <PageLayout title="Current Day Tour" backPath="/">
      <CurrentDayTour />
    </PageLayout>
  );
};

export default CurrentDayTourPage;
